import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  makeStyles,
  Grid,
  Divider,
} from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import MaskAndValid from "utils/maskAndValid";

const useStyles = makeStyles({
  root: {
    marginTop: 16,
  },
  title: {
    margin: "0.5rem 0",
    fontWeight: 500,
    color: "#263238",
  },
  head: {
    background: "transparent",
  },
  headCell: {
    color: "#90A4AE",
    fontWeight: 500,
    textAlign: "center",
    padding: "8px 16px",
  },
  cell: {
    textAlign: "center",
    padding: "8px 16px",
    color: "#263238",
  },
  actionCell: {
    textAlign: "center",
    padding: "8px 16px",
    minWidth: 90,
  },
  rowEven: {
    background: "#FAFBFD",
  },
  rowOdd: {
    background: "#fff",
  },
});

export default function TableFaixasBonificacao({ data, onEdit, onDelete }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {data.length > 0 && (
        <>
          <Grid item xs={12} style={{ marginTop: "1rem" }}>
            <Divider />
          </Grid>
          <Table>
            <TableHead>
              <TableRow className={classes.head}>
                <TableCell className={classes.headCell}>Bônus Meta</TableCell>
                <TableCell className={classes.headCell}>Mínimo</TableCell>
                <TableCell className={classes.headCell}>Máximo</TableCell>
                <TableCell className={classes.headCell}>Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, idx) => (
                <TableRow
                  key={idx}
                  className={idx % 2 === 0 ? classes.rowEven : classes.rowOdd}
                >
                  <TableCell className={classes.cell}>
                    {row.bonusType === "P"
                      ? `% ${MaskAndValid.maskDecimal(row.bonusValue, 3)}`
                      : `R$ ${MaskAndValid.maskPrice(row.bonusValue)}`}
                  </TableCell>
                  <TableCell className={classes.cell}>{row.min}%</TableCell>
                  <TableCell className={classes.cell}>
                    {row.max === 0 ? "-" : `${row.max}%`}
                  </TableCell>
                  <TableCell className={classes.actionCell}>
                    <Tooltip title="Editar Faixa">
                      <IconButton
                        size="small"
                        aria-label="edit"
                        onClick={() => onEdit(idx)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir Faixa">
                      <IconButton
                        size="small"
                        aria-label="delete"
                        onClick={() => onDelete(idx)}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </div>
  );
}
